import { createElement as _createElement } from "react";
import { forwardRef } from 'react';
import { BKJListItem } from '../../BKJListItem/index.js';
import { useBKJComboBoxAsyncContext } from './BKJComboBoxAsync.context.js';
export const BKJComboBoxAsyncItem = forwardRef((props, ref) => {
    const { value, index, label, style, disabled, type } = props;
    const { getItemProps, selectedItem, highlightedIndex, name, subLabelPosition } = useBKJComboBoxAsyncContext();
    const itemProps = getItemProps({
        item: props,
        isSelected: selectedItem?.value === value,
        index,
        value,
        label,
        checked: selectedItem?.value === value,
        disabled,
        style,
        name,
        ref,
    });
    // WEB-4815 / T020 / I-A05 / I-A06 / R7: the NoResults row must carry
    // aria-disabled="true" so AT announces the row as unavailable and axe
    // recognises the listbox has a child of role="option". The existing
    // highlight-skip logic (BKJComboBoxAsync.context.tsx onHighlightedIndexChange)
    // keeps aria-activedescendant from pointing at this id.
    const ariaDisabledAttr = type === 'NoResults' ? { 'aria-disabled': true } : {};
    return (_createElement(BKJListItem, { variant: "SpaceBetween", isTargeted: highlightedIndex === index, ...itemProps, ...ariaDisabledAttr, selected: [selectedItem?.value], ref: ref, key: `${value}`, subLabel: props?.subLabel, subLabelPosition: subLabelPosition, type: type }));
});
//# sourceMappingURL=BKJComboBoxAsyncItem.js.map